import { useState, useEffect } from "react";
import {
  Container,
  Box,
  Button,
  CircularProgress,
  Paper,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Modal,
  Card,
  CardContent,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  TextField

} from "@mui/material";
import Logocolor from "../../Image/Logo.png";
import {
  Texto,
  buttonGuardar,
  Input,
  buttonCancelar,
  TituloColor,
  modalStyle,
  InputBuscador,
  inputFecha,
  InputDescripcion
} from "../../Layouts/CustomStyles";
import { BsFileEarmarkRuledFill } from "react-icons/bs";
import { cargaMasivaSPA, useGetSAP } from "../../Services/SAP";
import { IoClose } from "react-icons/io5";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { DiseñoDataGrid } from "../../Components/FuncionesGenerales/DataGrid";
import { FormatRut } from "../../Components/FuncionesGenerales/Rut";
import { formatCLP } from "../../Components/FuncionesGenerales/FormatoCLP";
import { GiMoneyStack } from "react-icons/gi";
import SearchIcon from "@mui/icons-material/Search";
import { IoTrash } from "react-icons/io5";
import { useSAP } from "../../Services/SAP";
import { DataGrid } from "@mui/x-data-grid";

export const PaginaReporteSAP = () => {
  const [openConfirmEliminar, setOpenConfirmEliminar] = useState(false);
  const {
    allSap,
    loadingAllSAP,
    refetchSAP,
    sapBruto,
    loadingAllSAPBruto,
  } = useGetSAP();
  const [openImportDialog, setOpenImportDialog] = useState(false);
  const [formData, setFormData] = useState({
    archivo: null,
  });
  const { eliminarSapMesyAño, editarSap } = useSAP();
  const [successAlertOpen, setSuccessAlertOpen] = useState(false);
  const [errorAlertOpen, setErrorAlertOpen] = useState(false);
  const [enviandoAlert, setEnviandoAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [totalBrutoUltimoMes, setTotalBrutoUltimoMes] = useState(0);
  const [ultimoMesNombre, setUltimoMesNombre] = useState("");
  const [totalesPorSucursales, setTotalesPorSucursales] = useState([]);

  const [filtroSucursal, setFiltroSucursal] = useState(""); // ej: "UTRHKINE"
  const [openEliminarDialog, setOpenEliminarDialog] = useState(false);
  const [mesEliminar, setMesEliminar] = useState('');
  const [anioEliminar, setAnioEliminar] = useState('');
  const [selectedIngreso, setSelectedIngreso] = useState(null);
  const [openEdit, setOpenEdit] = useState(false);
  const [mes, setMes] = useState("");
const [anio, setAnio] = useState("");


useEffect(() => {
  refetchSAP({
    mes: mes || undefined,
    anio: anio || undefined,
    sucursal: filtroSucursal || undefined,
  });
}, [mes, anio, filtroSucursal]);


  const handleOpenEdit = (row) => {
    setSelectedIngreso(row);
    setOpenEdit(true);
  };

  const handleCloseEdit = () => {
    setOpenEdit(false);
    setSelectedIngreso(null);
  };

  const handleEditarIngreso = async () => {
    if (!selectedIngreso) return;

    try {
      setEnviandoAlert(true);

      const payload = {
  episodio: selectedIngreso.episodio,
  rut_paciente: selectedIngreso.rut_paciente,
  prevision: selectedIngreso.prevision,
  organizacion_gestora: selectedIngreso.organizacion_gestora,
  descripcion: selectedIngreso.descripcion,
  valor_neto: Number(selectedIngreso.valor_neto),
  valor_bruto: Number(selectedIngreso.valor_bruto),
  valor_exento: Number(selectedIngreso.valor_exento),
  valor_iva: Number(selectedIngreso.valor_iva),
  rut_profesional: selectedIngreso.rut_profesional,
  nombre_profesional: selectedIngreso.nombre_profesional,
};



      await editarSap(selectedIngreso.id, payload);

      setAlertMessage("Ingreso actualizado correctamente ✅");
      setSuccessAlertOpen(true);
      refetchSAP(); // recarga la lista

      handleCloseEdit(); // cierra el modal
    } catch (error) {
      setAlertMessage(`Error al actualizar: ${error}`);
      setErrorAlertOpen(true);
    } finally {
      setEnviandoAlert(false);
    }
  };



  const handleFileChange = (e) => {
    setFormData({ archivo: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.archivo) {
      setAlertMessage("Por favor selecciona un archivo Excel antes de continuar.");
      setErrorAlertOpen(true);

      return;
    }
    setEnviandoAlert(true);
    const formDataToSend = new FormData();
    formDataToSend.append("archivo", formData.archivo);

    try {

      await cargaMasivaSPA(formDataToSend);
      setEnviandoAlert(false); // ✅ se usa la función directamente
      setAlertMessage("Archivo importado correctamente ✅");
      setSuccessAlertOpen(true);
      setFormData({ archivo: null });
      setOpenImportDialog(false);
      refetchSAP();
    } catch (error) {

      setAlertMessage("Ocurrió un error al importar el archivo ❌", error);
      setErrorAlertOpen(true);

    } finally {

      setEnviandoAlert(false);
    }
  };
  const nombresMeses = [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
  ];
  // Opciones de mes/año únicas
  const opcionesMesAnio = Array.from(
    new Set(
      allSap.map(item => {
        const [anio, mes] = item.fecha_inicio_prestacion.split('-'); // ej: "2025-09-01" -> ["2025","09","01"]
        return `${anio}-${Number(mes)}`; // convertir "09" a 9
      })
    )
  )
    .map(str => {
      const [anio, mes] = str.split('-').map(Number);
      return {
        value: str,
        label: `${nombresMeses[mes - 1]} ${anio}` // Septiembre 2025
      };
    })
    .sort((a, b) => {
      const [anioA, mesA] = a.value.split('-').map(Number);
      const [anioB, mesB] = b.value.split('-').map(Number);
      if (anioA !== anioB) return anioB - anioA;
      return mesB - mesA;
    });


  const mapaSucursales = {
    "UTRHKINE": "Rahue",
    "UTKINESI": "Zenteno",
    "UTPRAACT": "Zenteno",
    "UTLUKINE": "La Unión",
    "UTLUACBO": "La Unión",
    "UTCMCBO": "Zenteno",
    "RHUTCCBO" : "Rahue",
    "UQPABCEN": "Hospitalizados Zenteno"
  };

  // Opciones de sucursales únicas
  const opcionesSucursal = Array.from(
    new Set(allSap.map(item => mapaSucursales[item.organizacion_gestora] || "Sin asignar"))
  ).map(nombre => ({
    value: nombre,  // se usará para filtrar
    label: nombre   // se muestra en el select
  }));


  const columns = [
    {
      field: "fecha_inicio_prestacion", headerName: "Fecha", width: 130,

      renderCell: (params) => {
        const fecha = new Date(params.row.fecha_inicio_prestacion);
        const dia = fecha.getUTCDate();
        const mes = fecha.getUTCMonth() + 1;
        const anio = fecha.getUTCFullYear();
        return `${dia.toString().padStart(2, '0')}-${mes.toString().padStart(2, '0')}-${anio}`;
      }
    },
    {
      field: "organizacion_gestora",
      headerName: "Sucursal",
      width: 180,
      renderCell: (params) => {
        const cod = params.value;

        let nombreSucursal = "";

        switch (cod) {
         case "UTRHKINE":
          case "RHUTCCBO":
            nombreSucursal = "Rahue";
            break;
          case "UTKINESI":
          case "UTPRAACT":
             case "UTCMCBO":
            nombreSucursal = "Zenteno";
            break;
          case "UTLUKINE":
          case "UTLUACBO":
            nombreSucursal = "La Unión";
            break;
         
          case "UQPABCEN":
            nombreSucursal = "Hospitalizados";
            break;
          default:
            nombreSucursal = "Sin asignar";
        }

        return (
          <div style={{ display: "flex", flexDirection: "row", fontFamily: "Poppins" }}>
            <span style={{ fontWeight: 500, fontFamily: "Poppins" }}>{nombreSucursal} </span>
            <span style={{ fontWeight: 400, margin: '0 2px' }}>/</span>
            <span style={{ fontSize: "0.9em", color: "#666", fontFamily: "Poppins" }}>{cod}</span>
          </div>
        );
      },
    },
    { field: "episodio", headerName: "Episodio", width: 130 },
    { field: "rut_paciente", headerName: "Rut paciente", width: 130, renderCell: (params) => FormatRut(params.value) },
    { field: "prevision", headerName: "Prevision", width: 130 },
    { field: "valor_bruto", headerName: "Valor bruto", width: 130, renderCell: (params) => formatCLP(params.value) },
    { field: "valor_exento", headerName: "Valor exento", width: 130, renderCell: (params) => formatCLP(params.value) },
    { field: "valor_iva", headerName: "IVA", width: 80, renderCell: (params) => formatCLP(params.value) },
    { field: "valor_neto", headerName: "Valor neto", width: 130, renderCell: (params) => formatCLP(params.value) },
    {
      field: "descripcion", headerName: "Descripcion", width: 300, renderCell: (params) => {
        const nombre = params.value || "";
        // Convierte la primera letra en mayúscula y el resto en minúsculas
        const formateado =
          nombre.charAt(0).toUpperCase() + nombre.slice(1).toLowerCase();

        return (
          <span style={{ textTransform: "none", fontFamily: "Poppins" }}>
            {formateado}
          </span>
        );
      },
    },
    { field: "rut_profesional", headerName: "Rut profesional", width: 130, renderCell: (params) => FormatRut(params.value) },
    {
      field: "nombre_profesional",
      headerName: "Nombre profesional",
      width: 350,
      renderCell: (params) => {
        const nombre = params.value || "";
        // Convierte la primera letra en mayúscula y el resto en minúsculas
        const formateado =
          nombre.charAt(0).toUpperCase() + nombre.slice(1).toLowerCase();

        return (
          <span style={{ textTransform: "capitalize", fontFamily: "Poppins" }}>
            {formateado}
          </span>
        );
      },
    },
    {
      field: "acciones",
      headerName: "Acciones",
      sortable: false,
      filterable: false,
      width: 150,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              display: "flex",
              gap: 1,
              width: 150,
              height: 80,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <button className="edit-button" onClick={() => handleOpenEdit(params.row)}>
              <svg className="edit-svgIcon" viewBox="0 0 512 512">
                <path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32z" />
              </svg>
            </button>

          </Box>
        );
      },
    },
  ];

 
  const meses = [
  { value: 1, label: "Enero" },
  { value: 2, label: "Febrero" },
  { value: 3, label: "Marzo" },
  { value: 4, label: "Abril" },
  { value: 5, label: "Mayo" },
  { value: 6, label: "Junio" },
  { value: 7, label: "Julio" },
  { value: 8, label: "Agosto" },
  { value: 9, label: "Septiembre" },
  { value: 10, label: "Octubre" },
  { value: 11, label: "Noviembre" },
  { value: 12, label: "Diciembre" },
];


const anioActual = new Date().getFullYear();

const anios = Array.from(
  { length: 5 },
  (_, i) => anioActual - i
);


  useEffect(() => {
    if (!allSap || allSap.length === 0) return;

    const nombresMes = [
      "", "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
      "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];

    const gruposMesSucursal = {}; // agrupación mes + sucursal
    const gruposMes = {}; // agrupación solo por mes
    const fechasValidas = [];

    allSap.forEach((item) => {
      if (!item.fecha_inicio_prestacion) return;

      // Parsear fecha
      const [anio, mes, dia] = item.fecha_inicio_prestacion.split("-").map(Number);
      const fecha = new Date(anio, mes - 1, dia);
      fechasValidas.push(fecha);

      // Obtener nombre sucursal según código
      let nombreSucursal = "";  
      switch (item.cod) {
       case "UTRHKINE":
          case "RHUTCCBO":
            nombreSucursal = "Rahue";
            break;
          case "UTKINESI":
          case "UTPRAACT":
          case "UTCMCBO":
            nombreSucursal = "Zenteno";
            break;
          case "UTLUKINE":
          case "UTLUACBO":
            nombreSucursal = "La Unión";
            break;

          case "UQPABCEN":
            nombreSucursal = "Hospitalizados";
            break;
          default:
            nombreSucursal = "Sin asignar";
      }

      const valor = Number(item.valor_bruto);
      const claveMesSucursal = `${anio}-${mes}-${nombreSucursal}`;
      const claveMes = `${anio}-${mes}`;

      // Agrupar por mes + sucursal
      if (!gruposMesSucursal[claveMesSucursal]) {
        gruposMesSucursal[claveMesSucursal] = { mes, anio, nombreSucursal, total: 0 };
      }
      gruposMesSucursal[claveMesSucursal].total += isNaN(valor) ? 0 : valor;

      // Agrupar total mensual global
      if (!gruposMes[claveMes]) {
        gruposMes[claveMes] = { mes, anio, total: 0 };
      }
      gruposMes[claveMes].total += isNaN(valor) ? 0 : valor;
    });

    if (fechasValidas.length === 0) return;

    // Último mes existente
    const fechaMax = new Date(Math.max(...fechasValidas));
    const ultimoMes = fechaMax.getMonth() + 1;
    const ultimoAnio = fechaMax.getFullYear();

    // Convertir a lista ordenada para DataGrid
    const listaOrdenada = Object.values(gruposMesSucursal)
      .sort((a, b) => new Date(b.anio, b.mes - 1) - new Date(a.anio, a.mes - 1))
      .map((g, i) => ({
        id: i + 1,
        mes: `${nombresMes[g.mes]} ${g.anio}`,
        sucursal: g.nombreSucursal,
        total: g.total,
      }));


    const ultimoMesKey = `${ultimoAnio}-${ultimoMes}`;
    const totalUltimoMes = gruposMes[ultimoMesKey]?.total || 0;

    // Actualizar estados

    setTotalBrutoUltimoMes(totalUltimoMes);
    setUltimoMesNombre(`${nombresMes[ultimoMes]} ${ultimoAnio}`);
  }, [allSap]);

  useEffect(() => {
    if (allSap && allSap.length > 0) {
      // 1️⃣ Encontrar el último mes y año registrados
      const fechasValidas = allSap
        .filter(item => item.fecha_inicio_prestacion)
        .map(item => {
          const [anio, mes, dia] = item.fecha_inicio_prestacion.split("-").map(Number);
          return new Date(anio, mes - 1, dia);
        });

      if (fechasValidas.length === 0) return;

      const fechaMax = new Date(Math.max(...fechasValidas));
      const ultimoMes = fechaMax.getMonth();
      const ultimoAnio = fechaMax.getFullYear();

      // 2️⃣ Filtrar registros de ese mes y año
      const registrosUltimoMes = allSap.filter(item => {
        if (!item.fecha_inicio_prestacion) return false;
        const [anio, mes, dia] = item.fecha_inicio_prestacion.split("-").map(Number);
        const fecha = new Date(anio, mes - 1, dia);
        return fecha.getMonth() === ultimoMes && fecha.getFullYear() === ultimoAnio;
      });

      // 3️⃣ Agrupar por organización_gestora y sumar valor_bruto
      const grupos = {};

      registrosUltimoMes.forEach(item => {
        const cod = item.organizacion_gestora || "Sin asignar";

        // Asignar nombre según código
        let nombreSucursal = "";
        switch (cod) {
          case "UTRHKINE":
          case "RHUTCCBO":
            nombreSucursal = "Rahue";
            break;
          case "UTKINESI":
          case "UTPRAACT":
          case "UTCMCBO":
            nombreSucursal = "Zenteno";
            break;
          case "UTLUKINE":
          case "UTLUACBO":
            nombreSucursal = "La Unión";
            break;

          case "UQPABCEN":
            nombreSucursal = "Hospitalizados";
            break;
          default:
            nombreSucursal = "Sin asignar";
        }

        if (!grupos[cod]) {
          grupos[cod] = {
            codigo: cod,
            nombre: nombreSucursal,
            totalBruto: 0,
          };
        }

        grupos[cod].totalBruto += parseFloat(item.valor_bruto) || 0;
      });

      // 4️⃣ Convertir en array y ordenar por monto descendente
      const lista = Object.values(grupos).sort((a, b) => b.totalBruto - a.totalBruto);

      setTotalesPorSucursales(lista);
    }
  }, [allSap]);



  const columnsrow = [
    {
      field: "mes",
      headerName: "Mes",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const mesNum = parseInt(params.value, 10); // "09" → 9
        const mesTexto = nombresMeses[mesNum - 1] || "Mes desconocido";
        const anio = params.row.anio;
        return (
          <div style={{ display: "flex", flexDirection: "row", fontFamily: "Poppins" }}>
            <span style={{ fontWeight: 500 }}>{` ${mesTexto} ${anio}`}</span>
          </div>
        );
      }
    },
    { field: "total_bruto_mes", headerName: "Total Bruto", width: 130, headerAlign: "center", align: "right", renderCell: (params) => formatCLP(params.value) },
    // columnas dinámicas
    ...Object.keys(sapBruto[0] || {}).filter(k => !['id', 'mes', 'total_bruto_mes', 'anio'].includes(k)).map(k => ({
      field: k,
      headerName: k,
      width: 130,
      headerAlign: 'center',
      align: 'right',
      renderCell: (params) => formatCLP(params.value)
    }))
  ];


  const obtenerMesesYAniosRepetidos = (lista) => {
    const meses = {};
    const anios = {};

    lista.forEach((item) => {
      if (!item.fecha_inicio_prestacion) return;

      const [anio, mes] = item.fecha_inicio_prestacion.split("-"); // EJ: "2025", "10"

      // contar meses
      if (!meses[`${anio}-${mes}`]) meses[`${anio}-${mes}`] = 0;
      meses[`${anio}-${mes}`]++;

      // contar años
      if (!anios[anio]) anios[anio] = 0;
      anios[anio]++;
    });

    const mesesRepetidos = Object.entries(meses)
      .filter(([_, count]) => count > 1)
      .map(([mesAnio]) => mesAnio);

    const aniosRepetidos = Object.entries(anios)
      .filter(([_, count]) => count > 1)
      .map(([anio]) => anio);

    return {
      mesesRepetidos,
      aniosRepetidos
    };
  };

  // === OBTENER RESULTADO ===
  const { mesesRepetidos, aniosRepetidos } = obtenerMesesYAniosRepetidos(allSap);

  // === PASARLOS A SELECT ===
  const mesesDisponibles = [...new Set(
    mesesRepetidos.map((m) => m.split("-")[1]) // solo mes
  )];


  const aniosDisponibles = [...new Set(aniosRepetidos)];

  return (
    <Container maxWidth="xl" sx={{ py: 5 }}>
      <Paper
        elevation={4}
        sx={{
          p: 4,
          borderRadius: "20px",
          background: "linear-gradient(145deg, #ffffff, #f4f6f8)",
          boxShadow: "0 10px 30px rgba(0,0,0,0.1)"
        }}
      >
        <Box sx={{
          display: "flex",
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Box display="flex" alignItems="center" gap={2}>
            <img
              src={Logocolor}
              alt="Logo Clínica Activa"
              style={{ width: 55, height: 55, objectFit: "contain" }}
            />
            <Typography variant="h5" sx={Texto}>
              Ingreso de reporte SAP CBO
            </Typography>
          </Box>

          <Box display="flex" alignItems="center" gap={2}>
            <Button
              startIcon={< BsFileEarmarkRuledFill />}
              sx={buttonGuardar}
              onClick={() => setOpenImportDialog(true)}

            >
              importar Archivo SAP
            </Button>
            <Button
              startIcon={< IoTrash />}
              sx={buttonCancelar}
              onClick={() => setOpenEliminarDialog(true)}

            >
              eliminar Archivo Sap
            </Button>
          </Box>
        </Box>

        <Box mt={4} mb={5}>
          <Card
            sx={{
              width: '700px',
              flex: 1,
              backgroundColor: "#ffffff", // blanco limpio
              borderRadius: 3,            // bordes redondeados
              boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)", // sombreado sutil
              transition: "transform 0.2s, box-shadow 0.2s",

            }}
          >
            <CardContent gap={1} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between  ', alignItems: 'center' }}>
              <Box sx={{ width: '80%', flexDirection: 'column', display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }} gap={1} mb={1}>
                <Typography variant="h4" fontWeight={400} sx={{ fontFamily: 'Poppins', color: '#585857' }}>
                  {formatCLP(totalBrutoUltimoMes)}
                </Typography>
                <Typography
                  variant="h6"
                  fontWeight={500}
                  sx={{ fontFamily: "Poppins", color: "#585857" }}
                >
                  Total Bruto{" "}
                  <Box component="span" sx={{ color: "#2a8d74", fontWeight: 500 }}>
                    Monto del mes {ultimoMesNombre || ""}
                  </Box>
                </Typography>
              </Box>

              <Box>
                <GiMoneyStack size={60} color="#5cd09aff" />
              </Box>
            </CardContent>
          </Card>
        </Box>
        <Box mb={4}>
          <Typography
            variant="h6"
            fontWeight={600}
            sx={{
              fontFamily: "Poppins",
              color: "#274a41ff",
              mb: 2,
              fontSize: '1rem'

            }}
          >
            Total del mes por sucursales {ultimoMesNombre || ""}
          </Typography>

          <Grid container spacing={2} mb={4}>
            {totalesPorSucursales.length > 0 ? (
              totalesPorSucursales.map((sucursal) => (
                <Grid size={{ xs: 12, sm: 6, md: 4 }} key={sucursal.codigo}>
                  <Card
                    sx={{
                      backgroundColor: "#f9f9f9",
                      borderRadius: 3,
                      boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
                      p: 2,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      transition: "transform 0.2s ease",
                      "&:hover": {
                        transform: "translateY(-5px)",
                        boxShadow: "0px 6px 12px rgba(0,0,0,0.15)",
                      },
                    }}
                  >
                    <CardContent
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Box>
                        <Typography
                          variant="subtitle1"
                          sx={{ fontFamily: "Poppins", color: "#585857" }}
                        >
                          {sucursal.nombre} / {sucursal.codigo}
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            fontFamily: "Poppins",
                            fontWeight: 600,
                            color: "#2a8d74",
                          }}
                        >
                          {formatCLP(sucursal.totalBruto)}
                        </Typography>
                      </Box>
                      <GiMoneyStack size={40} color="#2a8d74" />
                    </CardContent>
                  </Card>
                </Grid>
              ))
            ) : (
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "Poppins",
                  color: "#888",
                  mt: 2,
                  textAlign: "center",
                  width: "100%",
                }}
              >
                No hay registrados este mes.
              </Typography>
            )}
          </Grid>
        </Box>
       <Box display="flex" gap={2} mb={2}>

  {/* MES */}
  <FormControl
    sx={{
      ...InputBuscador,
      minWidth: 180,
    }}
  >
    <InputLabel>Mes</InputLabel>

    <Select
      value={mes}
      label="Mes"
      onChange={(e) => setMes(e.target.value)}
    >
      <MenuItem value="">Todos</MenuItem>

      {meses.map((m) => (
        <MenuItem
          key={m.value}
          value={m.value}
        >
          {m.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>

  {/* AÑO */}
  <FormControl
    sx={{
      ...InputBuscador,
      minWidth: 150,
    }}
  >
    <InputLabel>Año</InputLabel>

    <Select
      value={anio}
      label="Año"
      onChange={(e) => setAnio(e.target.value)}
    >
      <MenuItem value="">Todos</MenuItem>

      {anios.map((a) => (
        <MenuItem
          key={a}
          value={a}
        >
          {a}
        </MenuItem>
      ))}
    </Select>
  </FormControl>


  

</Box>

        <Box sx={{ height: 600, width: "100%" }}>
          <DataGrid
            rows={allSap}          
            columns={columns}
            loading={loadingAllSAP}
            pageSizeOptions={[10, 25, 50]}
            initialState={{
              pagination: { paginationModel: { pageSize: 10, page: 0 } },
            }}
            slots={{ noRowsOverlay: DiseñoDataGrid }}
            getRowId={(row) => row.id}
            rowHeight={100}
            sx={{
              fontFamily: 'Poppins, sans-serif',
              '& .MuiDataGrid-columnHeaders': {
                color: '#113e21ff',
                fontWeight: 600,
                textTransform: 'capitalize',
              },
              '& .MuiDataGrid-cell': {
                textTransform: 'capitalize',
              },
            }}
          />


        </Box>


        <Box mt={4}>
          <Typography
            variant="h6"
            fontWeight={600}
            sx={{ fontFamily: "Poppins", color: "#113e21ff", mb: 2 }}
          >
            Totales por Mes y Sucursal
          </Typography>

          <div style={{ height: 400, width: "100%" }}>
            <DataGrid
              rows={sapBruto || []}
              columns={columnsrow}
              pageSize={5}
              loading={loadingAllSAPBruto}
              disableSelectionOnClick
              getRowId={(row) => row.anio + '-' + row.mes} // aquí defines un id único
              slots={{ noRowsOverlay: DiseñoDataGrid }}
              sx={{
                fontFamily: 'Poppins, sans-serif',
                '& .MuiDataGrid-columnHeaders': {
                  color: '#113e21ff',
                  fontWeight: 600,
                  textTransform: 'capitalize',
                },
                '& .MuiDataGrid-cell': {
                  textTransform: 'capitalize',
                },
              }}
            />


          </div>
        </Box>


      </Paper>

      <Dialog open={openImportDialog} onClose={() => setOpenImportDialog(false)} fullWidth maxWidth="md">
        <DialogTitle sx={TituloColor}>Importar documento Reporte SAP</DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent>
            <Box sx={{ mt: 3 }}>
              <Button sx={buttonGuardar} component="label">
                Subir archivo Excel
                <input
                  sx={Input}
                  type="file"
                  accept=".xlsx,.xls"
                  hidden
                  onChange={handleFileChange}
                />
              </Button>
            </Box>
            {/* Mostrar nombre del archivo seleccionado */}
            {formData.archivo && (
              <div style={{ fontSize: "0.9rem", color: "#555" }}>
                Archivo seleccionado: {formData.archivo.name}
              </div>
            )}

          </DialogContent>
          <DialogActions>
            <Button sx={buttonGuardar} type="submit" disabled={enviandoAlert}>
              {enviandoAlert ? <CircularProgress size={24} /> : "Importar"}
            </Button>
            <Button sx={buttonCancelar} onClick={() => setOpenImportDialog(false)}>
              Cancelar
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Dialog
        open={openEliminarDialog}
        onClose={() => setOpenEliminarDialog(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={TituloColor}>Eliminar Ingresos por Mes y Año</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
            <TextField
              sx={InputBuscador}
              select
              label="Mes"
              fullWidth
              required
              value={mesEliminar}
              onChange={(e) => setMesEliminar(e.target.value)}
            >
              {mesesDisponibles.length > 0 ? (
                mesesDisponibles.map((mes) => (
                  <MenuItem key={mes} value={mes}>
                    {nombresMeses[mes - 1]}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No hay meses disponibles</MenuItem>
              )}
            </TextField>


            <TextField
              sx={InputBuscador}
              select
              label="Año"
              fullWidth
              required
              value={anioEliminar}
              onChange={(e) => setAnioEliminar(e.target.value)}
            >
              {aniosDisponibles.length > 0 ? (
                aniosDisponibles.map((anio) => (
                  <MenuItem key={anio} value={anio}>
                    {anio}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No hay años disponibles</MenuItem>
              )}
            </TextField>

          </Box>
        </DialogContent>

        <DialogActions>
          <Button sx={buttonCancelar} onClick={() => setOpenEliminarDialog(false)}>
            Cancelar
          </Button>
          <Button
            sx={buttonGuardar}
            disabled={!mesEliminar || !anioEliminar}
            onClick={() => setOpenConfirmEliminar(true)}
          >
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>

            <Dialog
  open={openConfirmEliminar}
  onClose={() => setOpenConfirmEliminar(false)}
  maxWidth="xs"
  fullWidth
>
  <DialogTitle sx={{ color: "#b71c1c", fontWeight: 600 }}>
    Confirmar eliminación
  </DialogTitle>

  <DialogContent>
    <Typography sx={{ mt: 1 }}>
      ⚠️ Esta acción <strong>NO se puede deshacer</strong>.
    </Typography>

    <Typography sx={{ mt: 2 }}>
      ¿Estás segura que deseas eliminar todos los ingresos del
      <strong> mes {nombresMeses[mesEliminar - 1]}</strong> del
      <strong> año {anioEliminar}</strong>?
    </Typography>
  </DialogContent>

  <DialogActions>
    <Button
      sx={buttonCancelar}
      onClick={() => setOpenConfirmEliminar(false)}
    >
      Cancelar
    </Button>

    <Button
            sx={buttonGuardar}
            onClick={async () => {
              setEnviandoAlert(true);
              try {


                await eliminarSapMesyAño(Number(mesEliminar), Number(anioEliminar));
                setAlertMessage(`Se eliminaron los registros de ${mesEliminar}/${anioEliminar} ✅`);
                setSuccessAlertOpen(true);
                setEnviandoAlert(false);
                await refetchSAP();

              } catch (error) {
                setEnviandoAlert(false);
                setAlertMessage(error || "Error al eliminar registros ❌");
                setErrorAlertOpen(true);
              } finally {

                setEnviandoAlert(false);
                setOpenEliminarDialog(false);
              }
            }}
          >
            Eliminar
          </Button>
  </DialogActions>
</Dialog>


      <Dialog open={openEdit} onClose={handleCloseEdit} fullWidth maxWidth="sm">
        <DialogTitle sx={Texto}>Editar Ingreso SAP</DialogTitle>
        <DialogContent>
          {/* Aquí puedes poner un formulario con los campos de `selectedIngreso` */}
          <Box sx={{ display: "flex", flexDirection:'column',mt: 2, gap: 2, mb: 2 }}>
            <Box sx={{ mb: 2 }}>
              <TextField
                sx={Input}
                label="Episodio"
                fullWidth
                margin="dense"
                value={selectedIngreso?.episodio || ""}

                onChange={(e) =>
                  setSelectedIngreso({ ...selectedIngreso, episodio: e.target.value })
                }
              />
            </Box>

            <Box sx={{ mb: 2 }}>
              <TextField
                sx={Input}
                label="RUT Paciente"
                fullWidth
                margin="dense"
                value={selectedIngreso?.rut_paciente || ""}
                onChange={(e) => {
                  const valorFormateado = FormatRut(e.target.value);
                  setSelectedIngreso({ ...selectedIngreso, rut_paciente: valorFormateado });
                }}
              />
            </Box>
            <Box sx={{ mb: 2 }}>
              <TextField
                sx={Input}
                label="Prevision"
                fullWidth
                margin="dense"
                value={selectedIngreso?.prevision || ""}

                onChange={(e) =>
                  setSelectedIngreso({ ...selectedIngreso, prevision: e.target.value })
                }
              />
            </Box>
            <Box sx={{ mb: 2 }}>
              <FormControl fullWidth sx={Input}>
                <InputLabel id="sucursal-label">Sucursal</InputLabel>
                <Select
                  labelId="sucursal-label"
                  name="sucursal"
                  value={selectedIngreso?.organizacion_gestora || ""}
                  onChange={(e) =>
                    setSelectedIngreso({ ...selectedIngreso, organizacion_gestora: e.target.value })
                  }
                  label="Sucursal"
                >
                  {/* opción por defecto */}
                  <MenuItem value="UTRHKINE">UTRHKINE</MenuItem>
                  <MenuItem value="UTKINESI">UTKINESI</MenuItem>
                  <MenuItem value="UTPRAACT">UTPRAACT</MenuItem>
                  <MenuItem value="UTLUKINE">UTLUKINE</MenuItem>
                  <MenuItem value="UTLUACBO">UTLUACBO</MenuItem>
                  <MenuItem value="UTCMCBO">UTCMCBO</MenuItem>
                  <MenuItem value="RHUTCCBO">RHUTCCBO</MenuItem>
                  <MenuItem value="UQPABCEN">UQPABCEN</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <TextField
              sx={Input}

              fullWidth
              margin="dense"
              value={formatCLP(selectedIngreso?.valor_neto)}
              onChange={(e) => {
                // eliminar todo lo que no sea número
                const numericValue = e.target.value.replace(/\D/g, "");

                // actualizar monto y valor simultáneamente
                setSelectedIngreso({
                  ...selectedIngreso,
                  valor_neto: numericValue,

                });
              }}
            />
            <TextField
              sx={Input}

              fullWidth
              margin="dense"
              value={formatCLP(selectedIngreso?.valor_bruto)}
              onChange={(e) => {
                // eliminar todo lo que no sea número
                const numericValue = e.target.value.replace(/\D/g, "");

                // actualizar monto y valor simultáneamente
                setSelectedIngreso({
                  ...selectedIngreso,
                  valor_bruto: numericValue,

                });
              }}
            />
            <TextField
              sx={Input}

              fullWidth
              margin="dense"
              value={formatCLP(selectedIngreso?.valor_iva)}
              onChange={(e) => {
                // eliminar todo lo que no sea número
                const numericValue = e.target.value.replace(/\D/g, "");

                // actualizar monto y valor simultáneamente
                setSelectedIngreso({
                  ...selectedIngreso,
                  valor_iva: numericValue,

                });
              }}
            />
            <TextField
              sx={Input}

              fullWidth
              margin="dense"
              value={formatCLP(selectedIngreso?.valor_exento)}
              onChange={(e) => {
                // eliminar todo lo que no sea número
                const numericValue = e.target.value.replace(/\D/g, "");

                // actualizar monto y valor simultáneamente
                setSelectedIngreso({
                  ...selectedIngreso,
                  valor_exento: numericValue,

                });
              }}
            />
            <Box sx={{ mb: 2 }}>
              <TextField
                sx={Input}
                label="RUT Profesional"
                fullWidth
                margin="dense"
                value={selectedIngreso?.rut_profesional || ""}
                onChange={(e) => {
                  const valorFormateado = FormatRut(e.target.value);
                  setSelectedIngreso({ ...selectedIngreso, rut_profesional: valorFormateado });
                }}
              />
            </Box>
            <Box sx={{ mb: 2 }}>
              <TextField
                sx={Input}
                label="Nombre Profesional"
                fullWidth
                margin="dense"
                value={selectedIngreso?.nombre_profesional || ""}

                onChange={(e) =>
                  setSelectedIngreso({ ...selectedIngreso, nombre_profesional: e.target.value })
                }
              />
            </Box>
            <Box>
              <TextField
                sx={InputDescripcion}
                label="Observaciones"
                fullWidth
                margin="dense"
                value={selectedIngreso?.descripcion || ""}

                onChange={(e) =>
                  setSelectedIngreso({ ...selectedIngreso, descripcion: e.target.value })
                }
              />

            </Box>

          </Box>
          {/* Agrega más campos según necesites */}
        </DialogContent>
        <DialogActions>
          <Button sx={buttonCancelar} onClick={handleCloseEdit}>Cancelar</Button>
          <Button sx={buttonGuardar} onClick={handleEditarIngreso}>
            {enviandoAlert ? "Guardando..." : "Guardar"}
          </Button>

        </DialogActions>
      </Dialog>

      <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
        <Box sx={modalStyle}>
          <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
            <IoClose />
          </section>
          <section style={{ textAlign: "center" }}>
            <FaRegCircleCheck style={{ color: "green", fontSize: "2rem" }} />
            <p className="alert-text">{alertMessage}</p>
          </section>
        </Box>
      </Modal>

      <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
        <Box sx={modalStyle}>
          <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
            <IoClose />
          </section>
          <section style={{ textAlign: "center" }}>
            <BiErrorCircle style={{ color: "red", fontSize: "2rem" }} />
            <p className="alert-text">{alertMessage}</p>
          </section>
        </Box>
      </Modal>

      <Modal open={enviandoAlert}>
        <Box sx={modalStyle}>
          <section style={{ textAlign: "center", padding: "1rem" }}>
            <CircularProgress style={{ color: "#2a8d74" }} />
            <p className="alert-text">Procesando solicitud...</p>
          </section>
        </Box>
      </Modal>
    </Container>
  )
}